module.exports = __webpack_public_path__ + "static/img/resources-main-article-tag.71b0ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resources-main-article-tag.svg
// module id = cDf2
// module chunks = 1